const X2EARN_REWARD_CLASSES = new Set([
  'x2earn_reward',
  'x2earn_reward_claim',
  'x2earn_reward_distribution',
]);

function normalize(value) {
  return String(value || '').trim().toLowerCase();
}

export function rewardTokenOf(row = {}) {
  return String(
    row.token ?? row.token_symbol ?? row.tokenSymbol ?? row.symbol ?? row.asset ?? ''
  )
    .trim()
    .toUpperCase();
}

export function rewardRecipientOf(row = {}) {
  return normalize(
    row.to ??
      row.recipient ??
      row.receiver ??
      row.to_address ??
      row.toAddress ??
      ''
  );
}

export function rewardAmountOf(row = {}) {
  const amount = Number(
    row.amount_display ??
      row.amountDisplay ??
      row.amount ??
      row.value ??
      row.quantity ??
      row.qty ??
      0
  );
  return Number.isFinite(amount) ? amount : 0;
}

export function rewardTimestampOf(row = {}) {
  const raw =
    row.timestamp ??
    row.block_timestamp ??
    row.blockTimestamp ??
    row.ts ??
    0;
  const timestamp = Number(raw);
  if (!Number.isFinite(timestamp) || timestamp <= 0) return 0;
  return timestamp > 1e12 ? Math.floor(timestamp / 1000) : Math.floor(timestamp);
}

function isCashbackSemantics(row = {}) {
  const cls = normalize(row.classification || row.type);
  const economicClass = normalize(row.economicClassification || row.economicEventType);
  const providerType = normalize(row.providerSemanticType);
  return (
    cls === 'purchase_cashback' ||
    economicClass === 'purchase_cashback' ||
    economicClass === 'purchase_rebate_cashback' ||
    providerType === 'cashback'
  );
}

/**
 * X2Earn column is denominated in B3TR. It accepts current canonical reward
 * classes and legacy B3TR airdrops, while excluding cashback and unrelated
 * token airdrops such as vet.domains VNS.
 */
export function isX2EarnB3trRewardRow(row = {}) {
  if (rewardTokenOf(row) !== 'B3TR') return false;
  if (isCashbackSemantics(row)) return false;

  const cls = normalize(row.classification || row.type);
  if (X2EARN_REWARD_CLASSES.has(cls)) return true;

  // Legacy snapshots represented VeBetterDAO distributions as B3TR airdrops.
  if (cls === 'airdrop') return true;

  const protocolClass = normalize(row.protocolClassification);
  return (
    row.isX2EarnReward === true ||
    X2EARN_REWARD_CLASSES.has(protocolClass)
  );
}

export function isGovernanceB3trRewardRow(row = {}) {
  return (
    rewardTokenOf(row) === 'B3TR' &&
    normalize(row.classification || row.type) === 'governance_reward'
  );
}
